import moment from "moment";
import { AiFillDelete } from "react-icons/ai";
import {
    useAddMemberMutation,
    useDeleteTeamMutation,
} from "../../features/team/teamApi";
import { RiUserHeartLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useGetUsersQuery } from "../../features/auth/authApi";

export default function TeamCard({ team }) {
    const [getSelectedMember, setSelectedMember] = useState("");
    const [isMemberModalOpened, setMemberModalopened] = useState(false);
    // user info
    const { user } = useSelector((state) => state.auth);
    const { id, category, description, admin, members, color, date } =
        team || {};
    // delete team api
    const [deleteTeamApi] = useDeleteTeamMutation();
    // add member api
    const [addMemberApi] = useAddMemberMutation();
    // user info
    const { data: getUsers } = useGetUsersQuery() || [];

    // not added in team
    const notAdded = getUsers?.filter(
        (user) => !members.some((member) => member === user.email)
    );

    const option = notAdded?.map((user) => {
        return {
            label: user.email,
            value: user.email,
            info: user,
        };
    });

    // added user info in team
    const addedMembers = getUsers?.filter((user) =>
        members.some((member) => member === user.email)
    );
    // delete team handler
    const deleteTeamHandler = () => {
        deleteTeamApi({ id, admin });
    };
    // add member modal handler
    const addMemberHandler = () => {
        setMemberModalopened(!isMemberModalOpened);
    };

    // add member form handler
    const memberSubmit = (e) => {
        e.preventDefault();
        addMemberApi({
            id,
            member: user?.email,
            members: [...members, getSelectedMember],
        });
        setMemberModalopened(false);
    };

    return (
        <>
            <div
                className="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                draggable="true"
            >
                <OutsideClickHandler
                    onOutsideClick={() => {
                        setMemberModalopened(false);
                    }}
                >
                    <button
                        onClick={addMemberHandler}
                        className="absolute top-0 right-0 items-center w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 flex justify-center"
                    >
                        <svg
                            className="w-4 h-4 fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                        </svg>
                    </button>
                    {isMemberModalOpened && (
                        <div className="absolute w-10/12 bg-white p-3 rounded shadow-xl right-4 top-12">
                            <form onSubmit={memberSubmit}>
                                <Select
                                    className="text-sm"
                                    onChange={(e) => setSelectedMember(e.value)}
                                    options={option}
                                />
                                <button className="bg-[#FF5733] text-white text-sm px-3 py-2 mt-3 rounded">
                                    Add member
                                </button>
                            </form>
                        </div>
                    )}
                </OutsideClickHandler>

                {admin === user?.email && (
                    <button
                        onClick={deleteTeamHandler}
                        className="absolute top-0 right-6 items-center justify-center hidden w-6 hover:bg-red-200 hover:text-red-600 h-5 mt-3 mr-2 text-gray-500 rounded  group-hover:flex"
                    >
                        <AiFillDelete />
                    </button>
                )}

                <span
                    style={{
                        backgroundColor: color,
                        color: "white",
                    }}
                    className="flex items-center h-6 px-3 text-xs font-semibold text-pink-500 rounded-full"
                >
                    {category}
                </span>
                <h4 className="mt-3 text-sm font-medium">{description}</h4>
                <div className="member-info">
                    <div className="flex items-center mt-3 bg-green-200 text-green-700 rounded-full justify-between px-2">
                        <RiUserHeartLine className="mr-3" />({members.length})
                    </div>
                    {/* added members info */}
                    <div className="member-info-modal absolute inset-0 bg-white px-4 pt-4 invisible duration-200 rounded-lg">
                        <h2 className="mb-6">
                            <span className="font-black text-lg text-gray-700">
                                Members List:
                            </span>
                        </h2>
                        <div className="overflow-y-auto ">
                            <div className="grid grid-cols-4 h-[100px] gap-3">
                                {addedMembers?.map((m) => {
                                    return (
                                        <div key={m.id} className="relative">
                                            <img
                                                className="h-10 w-10 border-2 border-orange-500 rounded-full"
                                                src={m.avatar}
                                                alt={m}
                                            />
                                            <p className="text-xs pt-2">
                                                {/* {m.name} */}
                                                {m.email === admin ? (
                                                    <>
                                                        {m.name}
                                                        <p className="text-green-600 font-blod">
                                                            (Admin)
                                                        </p>
                                                    </>
                                                ) : (
                                                    m.name
                                                )}
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                    <div className="flex items-center">
                        <svg
                            className="w-4 h-4 text-gray-300 fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <span className="ml-1 leading-none">
                            {moment(date).format("MMMM D")}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}
